module.exports = __webpack_public_path__ + "static/img/xiaoKeBig.cee47444.png";